// src/api/api.js


const API_BASE =
  process.env.REACT_APP_API_BASE ||
  (window.location.hostname.includes("pos.sts-lb.net")
    ? "https://nodeapi.sts-lb.net"
    : "http://localhost:3000");


// --- token helpers (named exports expect these) ---
export function getToken() {
  return localStorage.getItem("sts_admin_token") || "";
}

export function setToken(token) {
  if (!token) localStorage.removeItem("sts_admin_token");
  else localStorage.setItem("sts_admin_token", token);
}

// --- helper to create full absolute url (for images etc) ---
export function apiUrl(path = "") {
  if (!path) return API_BASE;
  if (/^https?:\/\//i.test(path)) return path; // already absolute
  return `${API_BASE}${path.startsWith("/") ? "" : "/"}${path}`;
}

async function request(path, options = {}) {
  const url = apiUrl(path);

  const headers = new Headers(options.headers || {});
  headers.set("Accept", "application/json");

  // Attach token automatically unless caller already set Authorization
  const token = getToken();
  if (token && !headers.has("Authorization")) {
    headers.set("Authorization", `Bearer ${token}`);
  }

  const res = await fetch(url, { ...options, headers });

  // Parse JSON if possible, otherwise keep raw text
  const text = await res.text();
  let data;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = { raw: text };
  }

  if (!res.ok) {
    const msg =
      (data && (data.error || data.message)) ||
      `Request failed (${res.status})`;
    const err = new Error(msg);
    err.status = res.status;
    err.data = data;
    throw err;
  }

  return data;
}

// --- API client (named export "api" + default export) ---
export const api = {
  base: API_BASE,

  // AUTH
  async login(username, password) {
    return request("/auth/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username, password }),
    });
  },

  async me() {
    return request("/auth/me");
  },

  // ITEMS
  async listItems(search = "") {
    const qs = search ? `?search=${encodeURIComponent(search)}` : "";
    return request(`/items${qs}`);
  },

  // SALES
async listSales({ limit = 50, offset = 0 } = {}) {
  const qs = new URLSearchParams();
  if (limit) qs.set("limit", String(limit));
  if (offset) qs.set("offset", String(offset));
  const q = qs.toString();
  return request(`/sales${q ? `?${q}` : ""}`);
},

async getSale(idOrInvoice) {
  return request(`/sales/${encodeURIComponent(idOrInvoice)}`);
},


  async createItem(payload) {
    return request("/items", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
  },

  async updateItem(id, payload) {
    return request(`/items/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
  },

  async deleteItem(id) {
    return request(`/items/${id}`, { method: "DELETE" });
  },

  // UPLOAD
  async uploadImage(file) {
    const fd = new FormData();
    fd.append("image", file);

    // do NOT set Content-Type manually for FormData
    return request("/upload", {
      method: "POST",
      body: fd,
    });
  },
};

export default api;
